import React, { useState } from 'react';
import styled from 'styled-components';
import { Box as MuiBox } from '@mui/material';
import { MainMetricItem } from './MainMetricItem';
import ShowMoreButton from 'pages/PatientsPage/components/buttons/ShowMoreButton';

const MetricsCell = ({ metrics, id, isActive }) => {
  const [hidden, setHidden] = useState(true);

  return (
    <MetricsCellContainer>
      <MuiBox
        sx={{
          display: 'flex',
          width: '360px',
          alignItems: 'center',
          flexWrap: 'wrap',
        }}
      >
        {metrics && (
          <>
            <MainMetricItem metric={metrics[0]} id={id} isActive={isActive} />
            <MainMetricItem metric={metrics[1]} id={id} isActive={isActive} />
          </>
        )}
        {/*eslint array-callback-return: ["error", { allowImplicit: true }]*/}
        {!hidden &&
          metrics?.map((metric, idx) => {
            if (idx > 1) {
              return (
                <MainMetricItem
                  key={id + ' ' + idx}
                  metric={metric}
                  id={id}
                  isActive={isActive}
                />
              );
            }
            return;
          })}
        {metrics?.length > 2 && (
          <ShowMoreButton
            isHidden={hidden}
            labelOnHidden={`+${metrics?.length - 2}`}
            labelOnDisplayed="<"
            onClick={setHidden}
          />
        )}
      </MuiBox>
    </MetricsCellContainer>
  );
};

export default MetricsCell;

const MetricsCellContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  white-space: nowrap;
  width: 'fit-content';
`;
